// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__SetCurrentTime from "./setCurrentTime.jsx";
import * as Subsonic__GetPlayQueue from "../api/subsonic/getPlayQueue.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    const credentials = state.auth.credentials;
    if (credentials !== undefined) {
      return Fx.Monad_syntax.let$star(Fx.$$catch(Fx.provide(Subsonic__GetPlayQueue.make(undefined), {
        credentials: credentials
      }), (function (error) {
        if (/* tag */ typeof error === "number" || typeof error === "string" || !(error.TAG === /* ApiError */ 2 && error.code === 70)) {
          return {
            TAG: /* Error */ 1,
            _0: error
          };
        } else {
          return {
            TAG: /* Ok */ 0,
            _0: undefined
          };
        }
      })), (function (playQueue) {
        const currentSongId = Stdlib__Option.bind(playQueue, (function (x) {
          return x.current;
        }));
        Stdlib__Option.iter((function (param) {
          Fx.runAsync(StoreFx__SetCurrentTime.make(function (param) {
            return Stdlib__Option.value(Stdlib__Option.bind(playQueue, (function (x) {
              return x.position;
            })), 0.0) / 1000.0;
          }), {
            store: store
          });
        }), currentSongId);
        return {
          TAG: /* Ok */ 0,
          _0: (store.setState(function (prevState) {
            const init = prevState.player;
            const arg = [];
            const state = store.getState();
            const entry = Stdlib__Option.map((function (x) {
              return x.entry;
            }), playQueue);
            return {
              albums: prevState.albums,
              artists: prevState.artists,
              auth: prevState.auth,
              player: {
                buffered: init.buffered,
                currentSongId: currentSongId,
                currentTime: init.currentTime,
                duration: init.duration,
                muted: init.muted,
                paused: init.paused,
                queuedSongIds: (function (param) {
                  return Stdlib__Option.value(param, arg);
                })(Stdlib__Option.map((function (x) {
                  return x.entry.map(function (song) {
                    return song.id;
                  });
                }), playQueue)),
                replayGainOptions: init.replayGainOptions,
                volume: init.volume
              },
              songs: {
                byId: entry !== undefined ? MergeIntoMap.mergeIntoMap(state.songs.byId, entry, (function (x) {
                    return x.id;
                  })) : state.songs.byId
              }
            };
          }), undefined)
        };
      }));
    } else {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
